import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsLoadingByType, RefuseExchangePayload, refuseExchangeOrder } from '@entities/exchange';

export function useRefuseExchange() {
	const dispatch = useDispatch();

	const isLoading = useSelector(getIsLoadingByType('refuse-exchange'));

	const onRefuseExchange = useCallback(
		(payload: RefuseExchangePayload) => {
			dispatch(refuseExchangeOrder(payload));
		},
		[dispatch]
	);

	return { onRefuseExchange, isLoading };
}
